var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cat",class:[_vm.stateClass, {
	'can-feed': _vm.canFeed,
	'sm-scale': _vm.scale < 0.4,
}],on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.tryFeed($event)}}},[_c('CatAnimator',{attrs:{"breed":_vm.breed,"state":_vm.stateClass,"initialState":_vm.initialState,"walkDistance":_vm.walkDistance},on:{"feedingComplete":_vm.completeRemoval,"walkComplete":_vm.completeWalk,"hasDied":function($event){_vm.$emit('died')}}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-718d042e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cat/Cat.vue
// module id = null
// module chunks = 